import React, { FC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'
import BasicText from '../../../Theme/Fonts/BasicText'
import { FixedMarginProps } from '../../../utils/styling/StylingHelper'
import Value from './HelperClass/Value'

export type MatchStatisticProps = {
    /** title of the statistic */
    title: string
    /** left side value */
    homeValue: number
    /** right side value */
    awayValue: number
    /** unit of the provided values */
    unit?: string
    /** Describes if home or away value is the winner */
    winner: 'HOME' | 'AWAY' | 'DRAW'
} & TestID &
    FixedMarginProps

const MatchStatistic: FC<MatchStatisticProps> = ({
    title,
    awayValue,
    homeValue,
    unit,
    winner,
    testID,
    ...margins
}) => {
    let homePercentage = homeValue > awayValue ? 100 : 0
    let awayPercentage = awayValue > homeValue ? 100 : 0
    if (!homePercentage && homeValue) {
        homePercentage = Math.floor((homeValue / awayValue) * 100)
    }
    if (!awayPercentage && awayValue) {
        awayPercentage = Math.floor((awayValue / homeValue) * 100)
    }

    return (
        <Grid noExpand backgroundColor="pearl" testID={testID} {...margins}>
            <BasicText
                textAlign="center"
                fontSize={['FS14', 'FS14', 'FS16']}
                lineHeight={['LH16', 'LH16', 'LH18']}
                color="onyx"
            >
                {title}
            </BasicText>
            <Grid noExpand width="100%" horizontal>
                <Value
                    type="HOME"
                    value={`${homeValue}${unit || ''}`}
                    percentage={homePercentage}
                    isWinner={
                        winner === 'HOME' || (homePercentage === 100 && awayPercentage === 100)
                    }
                />
                <Value
                    type="AWAY"
                    value={`${awayValue}${unit || ''}`}
                    percentage={awayPercentage}
                    isWinner={
                        winner === 'AWAY' || (awayPercentage === 100 && homePercentage === 100)
                    }
                />
            </Grid>
        </Grid>
    )
}

export default memo(MatchStatistic)
